import React, { memo } from "react";

import { useIsReadonly } from "@/components/PowerBlock/Block/readonly-context";
import { Toggle } from "@/components/Toggle";
import { Skeleton } from "@/components/ui/skeleton";

interface ReturnAllOutputsToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  isLoading?: boolean;
}

const ReturnAllOutputsToggle = memo(
  ({ enabled, onChange, isLoading = false }: ReturnAllOutputsToggleProps) => {
    const isReadonly = useIsReadonly();

    return (
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <span className="text-sm text-gray-700">Return All Outputs</span>
          <p className="mt-1 text-xs text-gray-500">
            When enabled, returns all intermediate outputs from the agent workflow execution
          </p>
        </div>
        {isLoading ? (
          <Skeleton width={44} height={24} borderRadius={12} />
        ) : (
          <Toggle enabled={enabled} setEnabled={onChange} disabled={isReadonly} />
        )}
      </div>
    );
  },
);

ReturnAllOutputsToggle.displayName = "ReturnAllOutputsToggle";

export default ReturnAllOutputsToggle;
